import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the electric icon
 * 
 * @param {Object} props - The props of the component
 * @returns The electric icon
 */
const ElectricIcon = (props) => (
  <Icon viewBox="0 0 13 16" fill="none" {...props}>
    <path d="M3.2 16.0029L4 10.4189H0L7.2 0.048584H8.8L8 6.4303H12.8L4.8 16.0029H3.2Z" fill="currentColor" />
  </Icon>
);

export default React.memo(ElectricIcon);
